import { render, staticRenderFns } from "./testTable.vue?vue&type=template&id=4f66e0be&scoped=true"
import script from "./testTable.vue?vue&type=script&lang=js"
export * from "./testTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f66e0be",
  null
  
)

export default component.exports